import { defineComponent as _defineComponent } from 'vue'
import CustomSelector from '@/components/custom_selector/CustomSelector.vue';
import { CityUtils } from '@/utils/city_utils';
import { StateUtils } from '@/utils/state_utils';
import { computed, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'CitySelector',
  props: {
    cityError: { type: String, required: false }
  },
  emits: ["change"],
  setup(__props: any, { expose: __expose }) {

const citySelector = ref<InstanceType<typeof CustomSelector>>();

const props = __props;

const stateCode = ref<string>('');



__expose({
  setState(stateName: string) {
    stateCode.value = stateName.length > 2 ? StateUtils.getStateCode(StateUtils.formatNameForSearch(stateName)) ?? '' : stateName;
    citySelector.value?.clearSelection();
  },
  setCity(cityName: string) {
    const cityIndex = CityUtils.findCityIndexByName(stateCode.value, cityName);
    if (cityIndex < 0) citySelector.value?.clearSelection();
    else citySelector.value?.setSelected(cityIndex);
  },
  setSelected(stateName: string, cityName: string) {
    this.setState(stateName);
    this.setCity(cityName);
  },
  clearSelection() {
    citySelector.value?.clearSelection();
  }
});


const __returned__ = { citySelector, props, stateCode, CustomSelector, get CityUtils() { return CityUtils } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})